import { render, staticRenderFns } from "./NaoxjStockInventory.vue?vue&type=template&id=742af3f4&scoped=true&"
import script from "./NaoxjStockInventory.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockInventory.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockInventory.vue?vue&type=style&index=0&id=742af3f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742af3f4",
  null
  
)

export default component.exports